import { HttpClient } from '../../httpClient'
import type { OpalApi } from '../../schema'

export const updateWorkflowStage: OpalApi<
  'UpdateWorkflowStageV3',
  200
> = async ({
  params,
  requestBody,
}: Parameters<OpalApi<'UpdateWorkflowStageV3', 200>>[0] = {}) => {
  const url = new URL(
    `/v3/workflow_stages/${params?.path.workflow_stage_id}`,
    window.location.origin
  )
  return HttpClient()
    .patch(url.toString(), requestBody)
    .then((res) => res.data)
}
